// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environment: 'local',

  /* ------------------ LAUNCH DARKLY ---------------*/
  launchDarklyClientId: '6412147a79a6f21342571797',
  bingMapsApiKey: '',

  /* ------------------ AUTH0 ---------------*/
  auth0: {
    domain: 'ptt.id.ups.com',
    clientId: 'uNMcUT8nHvocKUts1zLNEGExSaF0tCUU',
    audience: 'https://ptt.upstest.auth0app.com/api/v2/',
    redirectUri: 'http://localhost:4200/callback'
  },

  /* ------------------ FEATURE FLAGS ---------------*/
   trsNcmHeader:true
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
